export const getAIUrgenciesList = (t) => {
  return [
    { value: 'all', label: t('All') },
    { value: 3, label: t('Critical') },
    { value: 2, label: t('High') },
    { value: 1, label: t('Standard') },
  ];
};
